import type { IAccount } from '@jepto/shared/store/account/models/account.model';

/**
 * Incentives are on by default. Set `showIncentives: false` on an account to
 * opt out — so existing accounts do not need the field written on every item.
 */
export function resolveAccountShowIncentives(
	account: Pick<IAccount, 'showIncentives'> | null | undefined
): boolean {
	return account?.showIncentives !== false;
}
